<template>
  <div class="zone-input">
    <el-button size="small" @click="dialogObject = true">Разделы документации</el-button>
    <el-dialog v-loading="loader" title="Настроить по разделам документации" :visible.sync="dialogObject">
      <ZoneIndex isModal @edit-zone="editZone"/>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogObject = false">Закрыть</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="Редактирование раздела документации"
      :visible.sync="isEditZoneShow"
      width="30%"
    >
      <option-list   :form="form" v-model="_value" :type="type" :zone-id="editZoneId" />

      <div slot="footer" class="dialog-footer">
        <el-button @click="isEditZoneShow = false">Закрыть</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ZoneIndex from "./Index";
import AddOption from "../AddOption";
import draggable from 'vuedraggable';
import OptionList from "../OptionList";

export default {
  name: "DocsInputModal",
  components: {OptionList, AddOption, ZoneIndex, draggable},
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    form: Object,
    type: {
      type: String,
      default: 'materials'
    }
  },
  data() {
    return {
      dialogObject: false,
      isEditZoneShow: false,
      loader: false,
      editZoneId: null,
    }
  },
  methods: {
    editZone(id) {
      this.isEditZoneShow = true;
      this.editZoneId = id;
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>

<style lang="scss">
.zone-input {
  display: flex;
  justify-content: flex-start;
  .el-dialog {
    max-width: 720px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Inputs/Docs/DocsInputModal.vue